import React from 'react'
import { getTemplateComponent } from './templates'

const AppOnboardingNotification = ({ data = {}, onClose, onClick }) => {
  const notifType = data?.notif_type || {}
  const template = notifType.template || 'green_message'

  const TemplateComponent = getTemplateComponent(template)

  if (!TemplateComponent) {
    return null
  }

  return (
    <TemplateComponent
      id={data.id}
      title={notifType.title}
      content={notifType.content}
      buttonText={notifType.button_text}
      onClose={onClose}
      onClick={onClick}
    />
  )
}

export default AppOnboardingNotification
